import { HeartHandshake } from "lucide-react";
import React from "react";

export default function AllCampaignTier2Button() {
    return <div className="flex h-14 items-center  tablet:h-[40px]">  
     
     <HeartHandshake className="w-fit" />
        <span className="ms-3">Chiến dịch từng phần</span>
    </div>;
}
